<script>
import { calendarMixin } from '../../modules/calendar_module.js';
import { checkArrayOfObjectsValidity } from '../../modules/calendar_module.js';

export default {
  props: {
    "year": {
      type: Number,
      required: true,
      validator: (value) => (value % 1 === 0 && value >= 0)
    },
    "month": {
      type: Number,
      required: true,
      validator: (value) => (value >= 0 && value < 12)
    },
    "enablePopup": {
      type: Boolean,
      default: false,
    },
    "hiddenWeekDays": {
      type: Array,
      default: () => [],
      validator: (value) => {
        return value.length === 0 || value.reduce((result, v) => result && (v >= 0 && v < 7));
      }
    },
    // weekStartingDay: 1 for monday, 0 for sunday
    "weekStartingDay": {
      type: Number,
    },
    "events": {
      type: Object,
      default: () => { return {} },
      validator: (value) => {
        var response = true;
        const keys = ['title', 'description', 'color'];
        for(const prop in value) {
          response &= checkArrayOfObjectsValidity(value[prop], keys);
        };
        return response;
      }
    }
  },
  data() {
    return { };
  },
  mixins: [calendarMixin],
  methods: {
    isToday(day) {
      const today = (new Date()).toDateString();
      const date = (new  Date(this.year, this.month, day)).toDateString();
      return today === date;
    },
    dayClasses(day) {
      const classes = [];

      if (this.isToday(day)) {
        classes.push('today');
      }

      return classes;
    },
    dayStyles(day) {
      const style = {}
      const events = this.events[this.dateKey(new Date(this.year, this.month, day))];
      if (!!events) {
        console.log(events.length);
        switch (events.length) {
          case 1:
            style["background-color"] = events[0].color;
            break;
          case 2:
            style["background-color"] = events[0].color;
            style["background-image"] = `-webkit-linear-gradient(135deg, ${events[0].color} 50%, ${events[1].color} 50%)`;
            break;
          case 0:
            break;
          default:
            style["background-color"] = "#2020220";
            break;
        }
      }
      return style;
    } 
  },
  computed: {
    firstDayOfWeek() {
      return this.weekStartingDay || (globalState.lang === 'en' ? 0 : 1);
    },
    days() {
      let weekIndex = 0;
      const response = [];
      const numberOfDays = new Date(this.year, this.month + 1, 0).getDate();
      for (let i = 1; i <= numberOfDays; i++) {
        const date = new Date(this.year, this.month, i);
        const dayIndex = (date.getDay() - (this.firstDayOfWeek) + 7) % 7;
        response[weekIndex] = response[weekIndex] || new Array(7);
        response[weekIndex][dayIndex] = i;
        weekIndex = dayIndex !== 6 ? weekIndex : weekIndex + 1;
      }
      // workaround to hide weeks that have just not displayed days
      if (response[0][5] === 1 || response[0][6] === 1) {
        response.shift();
      }
      return response;
    }
  }
}
</script>

<template>
  <div class="w-100 h-100" calendar-month>
    <div class="text-center h4">
      {{ft('calendar.months')[month]}} {{year}}
    </div>
    <table class="w-100">
      <tr>
        <th v-for="(day, index) in ft('calendar.week_days')" :key="day" v-if="!hiddenWeekDays.includes(index)">
          <div class="position-absolute-center d-flex align-items-center justify-content-center">
            {{day}}
          </div>
        </th>
      </tr>
      <tr v-for="weekDays in days">
        <td v-for="(day, index) in weekDays" v-if="!hiddenWeekDays.includes(index)" :disabled="!day" :class="dayClasses(day)">
          <div class="m-1 position-absolute-center" :style="dayStyles(day)"></div>
          <div class="position-absolute-center d-flex align-items-center justify-content-center">
            {{day}}
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<style lang="scss">
[calendar-month] {

  th {
    color: $dark;
    background-color: $gray-200;
  }

  tr:not(:last-child) {
    border-bottom: 1px solid $gray-200;
  }

  td, th {
    position: relative;
    border: none;
    font-size: .75rem;
  }

  td:not([disabled]) {
    transition: background-color .25s;
    cursor: pointer;

    &:hover {
      background-color: $gray-300;
    }
  }

  td:after, th:after {
    content: '';
    display: block;
    margin-top: 100%;
  }

  td.today > div:first-child {
    border: 2px solid $dark;
  }
}
</style>